export const loadingColors = {
  foreground: "rgba(255,255, 255, .1)",
  background: "#000000"
}